export default "__VITE_ASSET__CFDVO5LB__"